/**
 * Given a lexicon, creates an accelerator for looking up Spelling Bee
 * solutions.
 */
export class SpellingBee {
  private readonly words: string[];

  constructor(words: string[]) {
    // Solutions must be 4 letters or more. Discard too-short words.
    this.words = words.filter(w => w.length >= 4);
  }

  matches(centerLetter: string, outerLetters: string): string[] {
    const allowedLetters = [...centerLetter, ...outerLetters];
    return this.words.filter(candidate =>
      candidate.includes(centerLetter) &&
      [...candidate].every(candidateLetter => allowedLetters.includes(candidateLetter))
    );
  }
}
